import script from "./MembresiasTab.vue?vue&type=script&setup=true&lang=js"
export * from "./MembresiasTab.vue?vue&type=script&setup=true&lang=js"

import "./MembresiasTab.vue?vue&type=style&index=0&id=4ff58ae4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ff58ae4"]])

export default __exports__